import { render, staticRenderFns } from "./ListHistory.vue?vue&type=template&id=1679469d&scoped=true"
import script from "./ListHistory.vue?vue&type=script&lang=js"
export * from "./ListHistory.vue?vue&type=script&lang=js"
import style0 from "./ListHistory.vue?vue&type=style&index=0&id=1679469d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679469d",
  null
  
)

export default component.exports